import gql from 'graphql-tag'

const getDriveSpreadsheetList = gql`
  query getSpreadsheetList(
    $refresh_token: String!
    $search: String
    $page_token: String
    $page_size: Float!
  ) {
    getSpreadsheetList(
      refresh_token: $refresh_token
      search: $search
      page_token: $page_token
      page_size: $page_size
    ) {
      incompleteSearch
      kind
      nextPageToken
      files {
        kind
        id
        name
        iconLink
      }
    }
  }
`

export default getDriveSpreadsheetList
